import { render, staticRenderFns } from "./works.vue?vue&type=template&id=2d8fe893&scoped=true&"
import script from "./works.ts?vue&type=script&lang=js&"
export * from "./works.ts?vue&type=script&lang=js&"
import style0 from "./works.less?vue&type=style&index=0&id=2d8fe893&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8fe893",
  null
  
)

export default component.exports